import * as Sentry from '@sentry/react'
import { strings } from '@crackpoint/shared/config'

const FallbackComponent = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h2>{strings.errors.genericTitle}</h2>
    <p>{strings.errors.genericDescription}</p>
    <button onClick={() => window.location.reload()}>{strings.errors.refreshButton}</button>
  </div>
)

export const ErrorBoundary = Sentry.withErrorBoundary(
  ({ children }: { children: React.ReactNode }) => <>{children}</>,
  { fallback: FallbackComponent }
)
